import { c as _c } from "react/compiler-runtime";
import React, { memo } from 'react';
import classNames from 'classnames';
import MaterialThumbnailPlaceholder from '../MaterialThumbnail/MaterialThumbnailPlaceholder';
const PLACEHOLDER_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9];

// Three desktop rows of nine, and three mobile rows of six
const LAYOUT_REVAMP_PLACEHOLDER_IDS = [...Array(27).keys()];
const LAYOUT_REVAMP_MOBILE_LIMIT = 18;
const MaterialThumbnailGroupPlaceholder = t0 => {
  const $ = _c(20);
  const {
    className,
    isLayoutRevamp: t1,
    variant
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const t2 = `relative w-full ${className}`;
  const t3 = !isLayoutRevamp && (variant === "PDPSelectUpholsteryUI" || variant === "PDPSelectUpholsteryUI--quickview");
  const t4 = variant === "PDPSelectUpholsteryUI--quickview";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = classNames(t2, {
      "max-[1023px]:[-ms-overflow-style:none] max-[1023px]:overflow-x-scroll max-[1023px]:overflow-y-hidden max-[1023px]:pl-5 max-[1023px]:relative max-[1023px]:[scrollbar-width:none] max-[1023px]:w-screen lg:max-[1023px]:h-[45px] max-[1023px]:md:pl-[3.333vw] [&::-webkit-scrollbar]:max-[1023px]:hidden": t3,
      "max-[1023px]:md:h-auto max-[1023px]:md:overflow-auto max-[1023px]:md:!p-0 max-[1023px]:md:w-auto": t4
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isLayoutRevamp || $[5] !== variant) {
    t6 = isLayoutRevamp ? "grid grid-cols-6 md:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] relative z-0" : classNames("max-[1023px]:flex max-[1023px]:max-w-full lg:grid lg:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] lg:relative lg:z-0", {
      "max-[1023px]:md:grid max-[1023px]:md:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] max-[1023px]:md:relative max-[1023px]:md:z-0": variant === "PDPSelectUpholsteryUI--quickview"
    });
    $[4] = isLayoutRevamp;
    $[5] = variant;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = isLayoutRevamp ? LAYOUT_REVAMP_PLACEHOLDER_IDS : PLACEHOLDER_IDS;
  let t8;
  if ($[7] !== isLayoutRevamp || $[8] !== t7 || $[9] !== variant) {
    let t9;
    if ($[11] !== isLayoutRevamp || $[12] !== variant) {
      t9 = id => <div className={classNames("h-full w-full", {
        "max-[1023px]:flex-shrink-0 max-[1023px]:h-[59px] max-[1023px]:min-w-[59px] max-[1023px]:w-[59px]": !isLayoutRevamp,
        "max-[1023px]:md:h-full max-[1023px]:md:min-w-[auto] max-[1023px]:md:w-full": !isLayoutRevamp && variant === "PDPSelectUpholsteryUI--quickview",
        "max-[767px]:hidden": isLayoutRevamp && id >= LAYOUT_REVAMP_MOBILE_LIMIT
      })} key={id}><MaterialThumbnailPlaceholder /></div>;
      $[11] = isLayoutRevamp;
      $[12] = variant;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    t8 = t7.map(t9);
    $[7] = isLayoutRevamp;
    $[8] = t7;
    $[9] = variant;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <div className={t6}>{t8}</div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t5 || $[18] !== t9) {
    t10 = <div className={t5} data-xc="MaterialThumbnailGroup">{t9}</div>;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
export default memo(MaterialThumbnailGroupPlaceholder);